<template>
	<div class="renewal-record">
		<div class="search-renewal-record">
			<div class="el-search vue-top-padding radius">
				<div class="el-left">
					<!--<el-button size="small" icon="el-icon-printer" hidden @click="exportOrder">导出</el-button>-->
				</div>
				<div class="el-right">
					<el-form
						ref="renewalRecord"
						:model="search"
						:inline="true"
						label-width="10px"
						size="small"
						class="demo-form-inline el-input-height">
						<el-form-item prop="userName">
							<el-input
								v-model="search.userName"
								:placeholder="$t('rechargeRecord.userName')"></el-input>
						</el-form-item>
						<el-form-item prop="withdrawalStatus">
							<el-select
								v-model="search.withdrawalStatus"
								:no-data-text="$t('common.noData')"
								:no-match-text="$t('common.noData')"
								clearable
								:placeholder="$t('myWallet.withdrawalStatus')">
								<el-option
									v-for="item in withdrawalStatusList"
									:key="item.id"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button
								type="primary"
								@click="onSubmit"
								icon="el-icon-search"
								>{{ $t("common.search") }}</el-button
							>
							<el-button @click="resetSearch()" icon="el-icon-refresh">{{
								$t("common.reset")
							}}</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="withdrawalRecordList"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					prop="userName"
					:label="$t('rechargeRecord.userName')"
					:show-overflow-tooltip="true"
					width="200"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="payeeName"
					:label="$t('Withdrawal.namepayee')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="bankName"
					:label="$t('Withdrawal.collectingbank')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="bankAccount"
					:label="$t('Withdrawal.worldfirst')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="price"
					:label="$t('Withdrawal.tixianjine')"
					:align="'center'"></el-table-column>
				<!-- <el-table-column prop="withdrawalStatus" :label="$t('Withdrawal.tixianzt')" width="150" :align="'center'">
                    <template slot-scope="scope">
                        <span v-if="scope.row.withdrawalStatus == 0" style="color: #e6a23c;">{{$t('rechargeRecord.confirmed')}}</span>
                        <span v-if="scope.row.withdrawalStatus == 1" style="color: #67c23a;">{{$t('rechargeRecord.done')}}</span>
                        <span v-if="scope.row.withdrawalStatus == 2" style="color: #f56c6c;">{{$t('rechargeRecord.caiwucancel')}}</span>
                        <span v-if="scope.row.withdrawalStatus == 3" style="color: #909399;">{{$t('rechargeRecord.cancelled')}}</span>
                    </template>
                </el-table-column> -->
				<el-table-column
					prop="createTime"
					:label="$t('Withdrawal.applytime')"
					width="160"
					:align="'center'"></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 180 : 180"
					:align="'center'">
					<template slot-scope="scope">
						<template v-if="scope.row.withdrawalStatus == 0">
							<el-button
								type="primary"
								size="mini"
								@click="nextStep(scope.row)">
								{{ $t("Withdrawal.confirmTx") }}
							</el-button>
							<el-button type="danger" size="mini" @click="revoke(scope.row)">
								{{ $t("renewalRecord.revoke") }}
							</el-button>
						</template>
						<template v-if="scope.row.withdrawalStatus == 1">
							<el-tag size="medium" type="success">{{
								$t("rechargeRecord.done")
							}}</el-tag>
						</template>
						<template v-if="scope.row.withdrawalStatus == 2">
							<el-tag size="medium" type="danger">{{
								$t("rechargeRecord.caiwucancel")
							}}</el-tag>
						</template>
						<template v-if="scope.row.withdrawalStatus == 3">
							<el-tag size="medium" type="info">{{
								$t("rechargeRecord.cancelled")
							}}</el-tag>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange">
			</el-pagination>
		</div>
		<!-- 密码输入框 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="this.$t('myWallet.dlmmH')"
			:visible.sync="dialogPwdVisible"
			width="400px"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			:show-close="false">
			<div style="display: flow-root">
				<el-input
					v-model="loginpassword"
					type="text"
					:placeholder="$t('myWallet.dlmmH')"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogPwdVisible = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="handleConfirm">{{
					$t("common.definite")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "WithdrawalRecord",
	data() {
		return {
			loading: false,
			search: {
				userName: "",
				withdrawalStatus: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			withdrawalRecordList: [],
			withdrawalStatusList: [],
			payStatus: "",
			dialogPwdVisible: false,
			loginpassword: "",
			localrow: {},
		};
	},
	mounted() {
		this.currentChange();
		this.listWithdrawalStatus();
	},
	methods: {
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.myWallet.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.withdrawalRecordList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		listWithdrawalStatus() {
			this.$api.dict("withdrawal_status").then(res => {
				if (res.code === 0) {
					this.withdrawalStatusList = res.data;
				}
			});
		},
		onSubmit() {
			this.currentChange(1);
		},
		resetSearch() {
			this.search.userName = "";
			this.search.withdrawalStatus = "";
			this.currentChange(1);
		},
		nextStep(row) {
			this.loginpassword = "";
			this.dialogPwdVisible = true;
			this.localrow = row;
		},
		handleConfirm() {
			let row = this.localrow;
			if (!this.loginpassword) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("myWallet.dlmmH"),
					type: "warning",
				});
				return false;
			}
			this.$api
				.request(this.$url.myWallet.confirm, this.$method.post, {
					id: row.id,
					password: this.$md5(this.loginpassword),
					withdrawalStatus: 1,
				})
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						this.currentChange();
						this.dialogPwdVisible = false;
					} else {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "warning",
						});
					}
				});
		},
		revoke(row) {
			this.$confirm(
				this.$t("rechargeRecord.revokeTixian"),
				this.$t("common.tip"),
				{
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}
			).then(() => {
				this.$api
					.request(this.$url.myWallet.cancel, this.$method.post, {
						id: row.id,
						withdrawalStatus: 2,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},
	},
};
</script>

<style lang="scss">
.el-dialog__body {
	height: auto !important;
}
</style>
